import { render, staticRenderFns } from "./TreeData.vue?vue&type=template&id=2b71a34e&scoped=true"
import script from "./TreeData.vue?vue&type=script&lang=js"
export * from "./TreeData.vue?vue&type=script&lang=js"
import style0 from "./TreeData.vue?vue&type=style&index=0&id=2b71a34e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71a34e",
  null
  
)

export default component.exports